import React from 'react';
import styled from 'styled-components';
import { layout, margin } from 'styled-system';

import useColors from 'hooks/use-colors';
import { AnchorButton } from 'src/components/core/button';
import { Heading2, Paragraph, SmallCapsSubtext } from '../typography';

export default function CtaBlock(props) {
  const { cta, route, description, label, title, variant = `default` } = props;
  const colors = useColors();
  return (
    <>
      <HeadingContainer {...props}>
        <SmallCapsSubtext color={colors.dutchiePlusGreen[35]}>{label}</SmallCapsSubtext>
        <Heading2>{title}</Heading2>
      </HeadingContainer>
      <ParagraphContainer {...props}>
        <Paragraph color={variant === 'dark' && colors.dutchiePlusBlue[45]}>{description}</Paragraph>
      </ParagraphContainer>
    </>
  );
}
const HeadingContainer = styled.div`
  max-width: 496px;
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    max-width: 325px;
    ${margin};
  }
  p {
    display: flex;
    margin-bottom: 24px;
    max-width: fit-content;
    place-items: center;
    place-content: center;
    ${({ theme }) => theme.breakpoints.down(`sm`)} {
      ${margin};
    }
  }
`;

const ParagraphContainer = styled.div`
  max-width: 424px;
  margin: 25px auto 44px 0;
  color: ${({ theme }) => theme.colors.dutchiePlusGrey[95]};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    margin: 15px auto 30px 0;
    max-width: 300px;
    ${layout};
  }
`;

const StyledAnchorButton = styled(AnchorButton)`
  background: transparent;
  border-color: ${({ theme }) => theme.colors.dutchiePlusGreen[35]};
  color: ${({ theme }) => theme.colors.dutchiePlusGreen[35]};
`;
